export const hasDensityMode = (el: HTMLElement): string => {
    let currentEl: HTMLElement | null = el;

    while (currentEl) {
        if (
            currentEl.classList &&
            (currentEl.classList.contains('sew-density-mode') ||
                currentEl.classList.contains('sew-default-mode'))
        ) {
            return 'has-density-mode';
        }
        currentEl = currentEl.parentElement || ((currentEl.getRootNode() as ShadowRoot).host as HTMLElement);
    }

    return '';
};
